"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var schedule = _interopRequireWildcard(require("@/api/schedule.js"));
var _creatJob = _interopRequireDefault(require("./creatJob"));
var _validate = require("@/utils/validate");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  name: 'list',
  components: {
    creatJob: _creatJob.default
  },
  data: function data() {
    return {
      tableData: [],
      listLoading: false,
      dialogVisible: false,
      status: 0,
      jobId: 0,
      editData: {
        jobId: 0,
        beanName: '',
        cronExpression: '',
        methodName: '',
        remark: '',
        param: ''
      }
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:schedule:job:list'])) this.getjobList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //权限控制
    // 获取定时任务列表
    getjobList: function getjobList() {
      var _this = this;
      this.listLoading = true;
      schedule.jobList().then(function (data) {
        _this.listLoading = false;
        _this.tableData = data;
      });
    },
    submit: (0, _validate.Debounce)(function (data) {}),
    //  关闭模态框
    handleClose: function handleClose(done) {
      this.formConf.fields = [];
      this.dialogVisible = false;
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this2 = this;
      if (row.status == 1) {
        schedule.scheduleJobSuspend(row.jobId).then(function () {
          _this2.$message.success('修改成功');
          _this2.getjobList();
        }).catch(function () {
          row.status = !row.status;
        });
      } else {
        schedule.scheduleJobStart(row.jobId).then(function () {
          _this2.$message.success('修改成功');
          _this2.getjobList();
        }).catch(function () {
          row.status = !row.status;
        });
      }
    },
    // 添加定时任务
    handleAddJob: function handleAddJob() {
      this.editData = {};
      this.dialogVisible = true;
    },
    // 修改定时任务
    onEdit: function onEdit(row) {
      this.editData = row;
      this.dialogVisible = true;
    },
    onTrig: function onTrig(row) {
      var _this3 = this;
      schedule.scheduleJobTrig(row.jobId).then(function (res) {
        _this3.$message.success('触发成功');
        _this3.getjobList();
      });
    },
    closeModel: function closeModel() {
      this.dialogVisible = false;
    },
    // 删除定时任务
    handleDelete: function handleDelete(id, idx) {
      var _this4 = this;
      this.$modalSure().then(function () {
        schedule.scheduleJobDelete(id).then(function (res) {
          _this4.$message.success('删除成功');
          _this4.getjobList();
        });
      });
    }
  }
};